import gsap from "gsap";
import { useLayoutEffect } from "react";
import bg from "../../images/bg.jpg";
import { ReactComponent as Arrow } from "../../images/arrow.svg";

const Welcome = () => {
    useLayoutEffect(() => {
        let ctx = gsap.context(() => {
			let startMarker = "85%";
			gsap.from("#welcomeTXT", {
				scrollTrigger: {
					trigger: ".welcomeBlock",
					start: `50 ${startMarker}`,
				},
				y: 50,
				opacity: 0,
				duration: .7,
                filter: "blur(10px)",
			})
            gsap.from("#welcomeSubTXT", {
				scrollTrigger: {
					trigger: ".welcomeBlock",
					start: `50 ${startMarker}`,
				},
				x: -50,
                delay: .1,
				opacity: 0,
				duration: .7,
                // filter: "blur(10px)",
			})
            gsap.from("#darkBG", {
				scrollTrigger: {
					trigger: ".welcomeBlock",
					start: `50 ${startMarker}`,
				},
				opacity: 0,
				duration: .7,
			})
			// gsap.from(slider.current, {
			// 	scrollTrigger: {
			// 		trigger: slider.current,
			// 		start: `100 ${startMarker}`,
			// 	},
			// 	y: 50,
			// 	filter: "blur(10px)",
			// 	opacity: 0,
			// 	duration: .7
			// })
			// gsap.from("#pricesControl", {
			// 	scrollTrigger: {
			// 		trigger: slider.current,
			// 		start: `70% ${startMarker}`,
			// 	},
			// 	y: 50,
			// 	scale: .8,
			// 	opacity: 0,
			// 	duration: .7
			// })
		});
		return () => ctx.revert();
    }, []);

    return (
        <div className="welcomeBlock">
            <div className="helloText">
                <h1 id="welcomeTXT">Устали считать вручную? Доверьте цифры нам!</h1>
                <div className="subTitle" id="welcomeSubTXT">
                    <h2>Рассчитывайте стоимость бухгалтерских услуг за минуту, экономьте время и увеличивайте прибыль.</h2>
                    <button className="activeButton" onClick={() => window.location.href = "https://calc.financeprice.ru/"}>
                        <div className="text">Попробовать бесплатно</div>
                        <Arrow/>  
                    </button>
                </div>
            </div>
            <div className="dark" id="darkBG"></div>
            <img src={bg} alt="finprice background" className="bg" />
        </div>
    )
}

export default Welcome;